<template>
  <div class="modal" id="modal_long_stay">
    <div class="content">
      <h2 class="content-title">{{$t('longStaySection.title')}}</h2>
      <p class="content-description">{{$t('longStayModal.p1')}}</p>
      <p class="content-description">{{$t('longStayModal.p2')}}</p>
      <p class="content-description">{{$t('longStayModal.p3')}}</p>
<!--      <p class="content-description">{{$t('longStayModal.p4')}}</p>-->
<!--      <p class="content-description">{{$t('longStayModal.p5')}}</p>-->
      <p class="content-description">{{$t('longStayModal.p6')}}</p>
      <p class="content-description">{{$t('longStayModal.p7')}}</p>
      <p class="content-description">{{$t('longStayModal.p8')}}</p>
      <ul>
        <li class="content-description">{{$t('longStayModal.p9')}}</li>
        <li class="content-description">{{$t('longStayModal.p10')}}</li>
        <li class="content-description">{{$t('longStayModal.p11')}}</li>
      </ul>
      <p class="content-description">{{$t('longStayModal.p12')}}</p>
      <p class="content-description">{{$t('longStayModal.p13')}}</p>
    </div>
  </div>

</template>

<script>
import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: 'LongStayModal',
  components: {hideAt, showAt},
  computed: {
    lang: function () {
      return this.$root.locale;
    }
  }
}
</script>
